import type { DashboardRecord } from "@/lib/dashboard/types";

export type DashboardOwner = "me" | "others";

export function dashboardOwner(dashboard: DashboardRecord): DashboardOwner {
  return isOwnDashboard(dashboard) ? "me" : "others";
}

export function canViewDashboardAudience(
  dashboard: DashboardRecord,
  profile: string | undefined,
): boolean {
  return profile === "nagra-admin" || dashboard.access?.owned === true;
}

/** Someone else's dashboard: what an unpublished draft must not be shown for. */
export function isOwnDashboard(dashboard: DashboardRecord): boolean {
  return dashboard.access?.owned !== false;
}
